/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyArrayType } from '../../models/key-array-type';
import { KeyType } from '../../models/key-type';

export interface GetDeliveryNoteKeysArchived$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;
}

export function getDeliveryNoteKeysArchived(http: HttpClient, rootUrl: string, params: GetDeliveryNoteKeysArchived$Params, context?: HttpContext): Observable<StrictHttpResponse<KeyArrayType>> {
  const rb = new RequestBuilder(rootUrl, getDeliveryNoteKeysArchived.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KeyArrayType>;
    })
  );
}

getDeliveryNoteKeysArchived.PATH = '/organization-sites/{organizationSiteKey}/consignor/delivery-notes/archived';
